import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedHrRoute({
  children,
  superAdminOnly = false,
}) {
  const user = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();

  // ❌ Not logged in
  if (!user) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  // ❌ Not HR
  if (!user?.is_hr) {
    return <Navigate to="/home" replace />;
  }

  // ❌ Super Admin required
  if (superAdminOnly && !user?.is_super_admin) {
    return <Navigate to="/home" replace />;
  }

  // ✅ Authorized
  return children;
}